import React from 'react';

const ACADEMY_PROMOTION_LOCK_MESSAGE =
  'Documents will only become available once all other promotion requirements have been met (mission tokens, total tokens, and time on rank), and at most 15 days remain before the required time at your current grade has elapsed.';

function LockedDocumentPlaceholders({ count, viewMode }) {
  const total = Math.max(0, Number(count) || 0);
  if (!total) return null;

  const items = Array.from({ length: total }, (_, index) => index);

  if (viewMode === 'list') {
    return (
      <div className="member-academy-document-list member-academy-document-list--locked">
        {items.map((key) => (
          <div
            key={key}
            className="member-academy-document-row member-academy-document-row--locked"
            aria-hidden
          />
        ))}
      </div>
    );
  }

  return (
    <div className="member-academy-document-grid member-academy-document-grid--locked">
      {items.map((key) => (
        <div
          key={key}
          className="member-academy-document-card member-academy-document-card--locked"
          aria-hidden
        />
      ))}
    </div>
  );
}

export default function AcademyCourseLockPanel({ course, viewMode, children }) {
  const locked = Boolean(course?.promotionGateLocked);
  if (!locked) return children;

  const documentCount = course.documentCount ?? course.documents?.length ?? 0;

  return (
    <div className="member-academy-detail__body member-academy-detail__body--locked">
      <div className="member-academy-detail__body-blur" aria-hidden="true">
        {children}
        <LockedDocumentPlaceholders count={documentCount} viewMode={viewMode} />
      </div>
      <div
        className="member-academy-detail__lock-card"
        role="status"
        aria-live="polite"
      >
        <p className="member-academy-detail__lock-card-title">Promotion requirements pending</p>
        <p className="member-academy-detail__lock-card-text">{ACADEMY_PROMOTION_LOCK_MESSAGE}</p>
      </div>
    </div>
  );
}

export { ACADEMY_PROMOTION_LOCK_MESSAGE };
